import type { Mesh, Scene } from "@babylonjs/core";
import type { Atmosphere } from "../scene";
import type { WorldConfig } from "../../world/config";
import { buildNomenStone } from "./nomenStone";
import { buildLibrary } from "./library";
import { buildFoundationRuin } from "./ruin";

export function buildLandmarks(scene: Scene, cfg: WorldConfig, height: (x: number, z: number) => number, atmosphere: Atmosphere): { floors: Mesh[] } {
  const floors: Mesh[] = [];
  // Solid landmark meshes also join the glow layer: with an include list, only listed meshes are
  // drawn into it, and a listed mesh with no emissive draws black there and hides glow behind it.
  // Without this the library's window glow bleeds through its own walls and the ruin columns.
  const cast = (ms: Mesh[]) => ms.forEach((m) => { atmosphere.addShadowCaster(m); atmosphere.addGlow(m); m.receiveShadows = true; });
  for (const l of cfg.landmarks) {
    const g = height(l.pos[0], l.pos[1]);
    if (l.type === "foundation-ruin") {
      const ruin = buildFoundationRuin(scene, l.pos, l.radius ?? 10, g);
      // the flat base only receives: at the low sun it would shadow itself into stripes (shadow acne)
      cast(ruin.filter((m) => m.name !== "ruin:base"));
      ruin.forEach((m) => { m.receiveShadows = true; });
    }
    if (l.type === "nomen-stone") {
      const { meshes, glow } = buildNomenStone(scene, l.pos, g);
      meshes.forEach((m) => { m.receiveShadows = true; });
      glow.forEach((m) => atmosphere.addGlow(m));
    }
    if (l.type === "library") {
      const parts = buildLibrary(scene, { pos: l.pos, yaw: l.yaw ?? 0, groundY: g });
      cast(parts.shadowCasters);
      parts.windows.forEach((m) => atmosphere.addGlow(m));
      parts.root.getChildMeshes().forEach((m) => { m.receiveShadows = true; });
      floors.push(parts.showcaseFloor);
    }
  }
  return { floors };
}
